import { render, staticRenderFns } from "./DiscoverDetail.vue?vue&type=template&id=2b3a4c72&scoped=true"
import script from "./DiscoverDetail.vue?vue&type=script&lang=js"
export * from "./DiscoverDetail.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./DiscoverDetail.vue?vue&type=style&index=1&id=2b3a4c72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a4c72",
  null
  
)

export default component.exports